<footer *ngIf="mode !== 'landing'" class="landing-footer-bar">
  <div class="footer-inner">
    <a class="footer-brand" [routerLink]="isDashboardRoute() ? '/dashboard/home' : '/'">
      <div class="footer-logo-wrap">
        <img src="Logo/logo-opt.webp" alt="Casinoze Logo" class="footer-logo-img" />
      </div>
    </a>

    <nav class="footer-nav">
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'dashboard'" (click)="GoToDashboard()">
        Dashboard
      </a>
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'wallet'" (click)="GoToWallet()">
        Wallet
      </a>
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'privacy'" (click)="GoToPrivacyPolicy()">
        Privacy
      </a>
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'terms'" (click)="GoToTermsAndConditions()">
        Terms
      </a>
    </nav>

    <div class="footer-right">
      <span class="footer-copyright">
        <span class="copyright-dot"></span> © 2026 Casinoze
      </span>
    </div>
  </div>
</footer>

<!-- Mobile Bottom Nav -->
<nav *ngIf="isDashboardRoute() && isScreenWidthLessThan800() && !isTreasurePickRoute()" class="mobile-bottom-nav">
  <a routerLink="/dashboard/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
    class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    </div>
    <span class="bottom-nav-label">Home</span>
  </a>

  <a routerLink="/dashboard/wallet" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
    class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    </div>
    <span class="bottom-nav-label">Wallet</span>
  </a>

  <button (click)="openDepositModal()" class="bottom-nav-deposit">
    <span class="deposit-fab">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
    </span>
    <span class="deposit-label">Deposit</span>
  </button>

  <button (click)="toggleNotifications()" class="bottom-nav-item" [class.active]="showNotifications">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      <span *ngIf="notificationCount > 0" class="notification-dot"></span>
    </div>
    <span class="bottom-nav-label">Alerts</span>
  </button>

  <a routerLink="/dashboard/profile" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
    class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>
    <span class="bottom-nav-label">Profile</span>
  </a>
</nav>

<!-- Mobile Bottom Nav (Guest / landing mode) -->
<nav *ngIf="mode === 'landing' && isScreenWidthLessThan800()" class="mobile-bottom-nav">
  <a (click)="guestHome()" class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    </div>
    <span class="bottom-nav-label">Home</span>
  </a>

  <a (click)="requestAuth('login')" class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    </div>
    <span class="bottom-nav-label">Wallet</span>
  </a>

  <button (click)="requestAuth('signup')" class="bottom-nav-deposit">
    <span class="deposit-fab">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
    </span>
    <span class="deposit-label">Deposit</span>
  </button>

  <a (click)="requestAuth('login')" class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    </div>
    <span class="bottom-nav-label">Alerts</span>
  </a>

  <a (click)="requestAuth('login')" class="bottom-nav-item">
    <div class="bottom-nav-icon-wrap">
      <svg class="bottom-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>
    <span class="bottom-nav-label">Profile</span>
  </a>
</nav>

<app-notifications *ngIf="showNotifications" [notifications]="notifications" mode="popup"
  (closeNotification)="showNotifications = false" (notificationsCount)="notificationCount = $event"
  (openChat)="onNotificationOpenChat()"></app-notifications>